import { colors, breakpoints } from '@web-for-marketing/react-ui';

export const articleStyles = {
    header: {
        display: 'block',
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none',
        },
    },
    blogContent: {
        [`@media (max-width: ${breakpoints.md})`]: {
            marginTop: 0,
        },
    },
    blogExtras: {
        [`@media (max-width: ${breakpoints.lg})`]: {
            marginTop: 0,
            paddingTop: '4rem !important',
        },
    },
    relatedPostContainer: {
        backgroundColor: colors.core.cloud,
        position: 'relative',
        '&:before': {
            content: '""',
            position: 'absolute',
            height: '100rem',
            width: '100%',
            top: '-100rem',
            left: 0,
            backgroundColor: colors.core.cloud,
            zIndex: -1,
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            backgroundColor: 'none',
            '&:before': {
                content: 'none',
            },
        },
    },
    centeredContainer: {
        maxWidth: '1612px',
        margin: 'auto',
        '@media (max-width: 1950px)': {
            maxWidth: 'calc(79.8611vw + 48px)',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            maxWidth: 'calc(77vw + 48px)',
        },
    },
    block: {
        display: 'block',
    },
    pressReleaseCard: {
        marginTop: '-20rem',
        marginBottom: '3rem',
        maxWidth: '100%',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginTop: 'unset',
            background: 'unset',
            boxShadow: 'unset',
            width: '100%',
        },
    },
    noHeaderMediaCard: {
        marginBottom: '3rem',
        maxWidth: '100%',
    },
    relatedPost: {
        maxWidth: '100%',
    },
    blogSideArea: {
        marginTop: '-20rem',
        marginBottom: '3rem',
        [`@media (max-width: ${breakpoints.lg})`]: {
            marginTop: 'unset',
            background: 'unset',
            boxShadow: 'unset',
        },
    },
    clientProfile: {
        maxWidth: '100%',
        margin: '8rem 0',
        [`@media (max-width: ${breakpoints.md})`]: {
            width: '100%',
            margin: '0',
        },
    },
    clientProfileHeader: {
        marginBottom: '3rem',
    },
    recentNewsContainer: {
        margin: '0 24px 80px',
    },
    downloadButton: {
        margin: '3rem 0',
    },
    heading: {
        fontWeight: '500',
        marginBottom: '2rem',
    },
    headerBackground: {
        position: 'relative',
        zIndex: 1,
        '&:before': {
            content: '""',
            position: 'absolute',
            height: '1500px',
            width: '100%',
            bottom: 0,
            left: 0,
            backgroundColor: colors.core.cloud,
            zIndex: -1,
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            '&:before': {
                content: 'none',
            },
        },
    },
    mobileWrap: {
        [`@media (max-width: ${breakpoints.lg})`]: {
            flexWrap: 'wrap',
        },
    },
} as const;
